import { render, staticRenderFns } from "./ListaEspera.vue?vue&type=template&id=5dffc31b&"
import script from "./ListaEspera.vue?vue&type=script&lang=js&"
export * from "./ListaEspera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports